import Cookies from 'js-cookie';
import configEnv from '@/enums/configEnv';

export const arrToSrcset = (arr) => {
  /* return array of wp image sizes to srcset string
  * arr - array
  */
  let result = '';
  if (arr) {
    ['large', 'medium', 'thumb'].forEach((size) => {
      const widthIndex = `${size}-width`;
      result += `${arr[size]} ${arr[widthIndex]}w, `;
    });
  }
  return result;
};

export const getUrlParameter = (parameter) => {
  const searchString = window.location.search;

  if (searchString) {
    const regex = new RegExp(`(?<=[?&]${parameter}=)[\\w]+(?=&)?`);
    const res = regex.exec(searchString);
    return Array.isArray(res) ? res[0] : undefined;
  }
  return undefined;
};

export const derivePartnerCode = (profilePartnerCode = undefined) => {
  /* eslint-disable-next-line no-underscore-dangle */
  const p_update = getUrlParameter('partner_code_update');
  const partner_code_update = p_update && p_update === '1';
  const url_partner_code = getUrlParameter('partner_code');
  const cookiePartnerCode = Cookies.get('partner_code');
  const default_partner_code = configEnv.server_type
    ? configEnv.server_type.toLowerCase() : 'wetterheld';

  // F+r prio partners are always taken from url and logic is skipped
  if (configEnv.prio_partners.includes(url_partner_code)) {
    return url_partner_code;
  }

  // Check if a valid profile partner code was provided
  const hasProfileCode = Boolean(profilePartnerCode && profilePartnerCode.trim() !== '');

  /**
   * Column 0: partner_code_update=1
   * Column 1: url_partner_code exists
   * Column 2: profilePartnerCode exists/valid
   * Column 3: cookiePartnerCode exists
   * Column 4: Ergebnis/Wert
   */
  const prios = [
    [true, true, undefined, undefined, url_partner_code],      /** Prio 1: partner_code_update=1 + url_partner_code exists */
    [true, false, undefined, undefined, default_partner_code],  /** Prio 2: partner_code_update=1 + url_partner_code not existing -> Default */
    [false, undefined, true, undefined, profilePartnerCode],    /** Prio 3  partner_code_update=0 + profilePartnerCode defined*/
    [false, undefined, false, true, cookiePartnerCode],        /** Prio 4: partner_code_update=0 +  profilePartnerCode undefined + cookiePartnerCode exists*/
    [false, true, false, false, url_partner_code],             /** Prio 5: partner_code_update=0 + profilePartnerCode undefined + cookiePartnerCode not exists + url_partner_code exists*/
    [false, false, false, false, default_partner_code],        /** Prio 6: Fallback / Default */
  ];

  let partnerCode = null;

  for (let i = 0; i < prios.length; i += 1) {
    const prio = prios[i];
    const check = [
      prio[0] === undefined || !!partner_code_update === prio[0],
      prio[1] === undefined || !!url_partner_code === prio[1],
      prio[2] === undefined || hasProfileCode === prio[2],
      prio[3] === undefined || !!cookiePartnerCode === prio[3],
    ];
    if (check.every((r) => r === true)) {
      [, , , , partnerCode] = prio;
      break;
    }
  }
  if (cookiePartnerCode && cookiePartnerCode !== partnerCode) {
    Cookies.remove('partner_code');
  }
  return partnerCode;
};

export const getLanguageFromLanguageParam = (lang) => {
  if (lang === '') {
    return configEnv.default_wp_language;
  }
  return lang;
};

export const addAmPm = (number) => {
  let ending = 'am';
  if (number >= 12) {
    ending = 'pm';
  }
  let hour = number % 12;
  if (hour === 0) {
    hour = 12;
  }
  return `${hour}${ending}`;
};
